module.exports = __webpack_public_path__ + "static/media/snow-flake.ec93d417.svg";